module.exports = __webpack_public_path__ + "static/media/Seraphine_0.7476a5e9.jpg";